module.exports = __webpack_public_path__ + "static/media/emoji-glowing-star.16faf905.svg";